<template>
  <div class="notfound-container">
    <img src="/404Owl.png" alt="Logo" class="notfound-logo" />
    <h1>404</h1>
    <h2>{{ t('notFound.pageNotFound') }}</h2>
    <p>{{ t('notFound.pageNotFoundDescription') }}</p>
    <router-link to="/dashboard" class="notfound-link">{{ t('notFound.goToDashboard') }}</router-link>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

</script>

<style scoped>
.notfound-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  min-width: 70%;
  text-align: center;
  background: #f8f9fa;
  border-radius: 16px;
  margin: 2rem auto;
  max-width: 500px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
  padding: 2rem 1rem;
}
.notfound-logo {
  width: 280px;
  margin-bottom: 1.5rem;
}
h1 {
  font-size: 4rem;
  color: #667eea;
  margin: 0;
}
h2 {
  font-size: 1.7rem;
  color: #333;
  margin-bottom: 0.5rem;
}
p {
  color: #666;
  margin-bottom: 1.5rem;
}
.notfound-link {
  display: inline-block;
  background: #764ba2;
  color: #fff;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: background 0.2s;
}
.notfound-link:hover {
  background: #125ea2;
}
</style>
